import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import { FiChevronLeft } from 'react-icons/fi'
import AdminService from '../../service/AdminService'
import '../styles/AdminForm.css'

const FormAdmin = () => {
  const navigate = useNavigate()
  const authorization = localStorage.getItem('token')

  const [form, setForm] = useState({
    nom: '', prenom: '', date: '', email: '', password: '', superAdmin: false,
  })

  const [errors, setErrors] = useState({})
  const [submitting, setSubmitting] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm((f) => ({ ...f, [name]: value }))
    if (errors[name]) setErrors((err) => ({ ...err, [name]: null }))
  }

  const handleSuperAdminChange = (e) => {
    setForm((f) => ({ ...f, superAdmin: e.target.checked }))
  }

  const validate = () => {
    const err = {}
    if (!form.nom.trim()) err.nom = 'Le nom est requis'
    if (!form.prenom.trim()) err.prenom = 'Le prénom est requis'
    if (!form.date) err.date = 'La date de naissance est requise'
    if (!form.email.trim()) err.email = "L'email est requis"
    if (!form.password) err.password = 'Le mot de passe est requis'
    setErrors(err)
    return Object.keys(err).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validate()) {
      document.querySelector('.ata-error')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      return
    }

    const data = {
      nom: form.nom,
      prenom: form.prenom,
      date: form.date,
      password: form.password,
      email: form.email,
      superAdmin: form.superAdmin,
    }

    setSubmitting(true)
    try {
      await AdminService.ajouter(data, authorization)
      toast.success('Administrateur ajouté avec succès')
      setTimeout(() => navigate('/admin/Registre'), 800)
    } catch (err) {
      toast.error(err.response?.data?.message || err.response?.data || "Échec de l'ajout")
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="ata-page">
      <Toaster />

      <div className="ata-header">
        <button type="button" className="ata-back" onClick={() => navigate('/admin/Registre')}>
          <FiChevronLeft size={16} />
        </button>
        <div>
          <h1 className="ata-title">Ajouter un administrateur</h1>
          <p className="ata-subtitle">Renseignez les informations du nouveau compte administrateur</p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="ata-col-right">
          <div className="ata-card">
            <div className="ata-card__label">Identité</div>

            <div className="ata-row">
              <div className="ata-field">
                <label>Nom *</label>
                <input type="text" name="nom" value={form.nom} onChange={handleChange} placeholder="Nom" className={errors.nom ? 'ata-input--error' : ''} />
                {errors.nom && <p className="ata-error">{errors.nom}</p>}
              </div>
              <div className="ata-field">
                <label>Prénom *</label>
                <input type="text" name="prenom" value={form.prenom} onChange={handleChange} placeholder="Prénom" className={errors.prenom ? 'ata-input--error' : ''} />
                {errors.prenom && <p className="ata-error">{errors.prenom}</p>}
              </div>
            </div>

            <div className="ata-field">
              <label>Date de naissance *</label>
              <input type="date" name="date" value={form.date} onChange={handleChange} className={errors.date ? 'ata-input--error' : ''} />
              {errors.date && <p className="ata-error">{errors.date}</p>}
            </div>
          </div>

          <div className="ata-card">
            <div className="ata-card__label">Compte</div>

            <div className="ata-field">
              <label>Email *</label>
              <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Email" className={errors.email ? 'ata-input--error' : ''} />
              {errors.email && <p className="ata-error">{errors.email}</p>}
            </div>

            <div className="ata-field">
              <label>Mot de passe *</label>
              <input type="password" name="password" value={form.password} onChange={handleChange} placeholder="Mot de passe" className={errors.password ? 'ata-input--error' : ''} />
              {errors.password && <p className="ata-error">{errors.password}</p>}
            </div>

            <div className="ata-field">
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={form.superAdmin}
                  onChange={handleSuperAdminChange}
                  style={{ width: 16, height: 16, padding: 0, border: 'none', background: 'none', accentColor: '#3b8bff', cursor: 'pointer', flexShrink: 0 }}
                />
                Compte Super Administrateur
              </label>
            </div>
          </div>
        </div>

        <div className="ata-footer-actions">
          <button type="button" className="ata-btn ata-btn--ghost" onClick={() => navigate('/admin/Registre')}>Annuler</button>
          <button type="submit" className="ata-btn ata-btn--primary" disabled={submitting}>
            {submitting ? (<><span className="ata-spinner" /> Ajout…</>) : 'Ajouter'}
          </button>
        </div>
      </form>
    </div>
  )
}

export default FormAdmin
